module.exports = __webpack_public_path__ + "img/FGr_Logistik_Materialerhaltungstrupp.8311cb19.svg";